import { TailSpin } from "react-loader-spinner";
import "./index.css";

function LoadingComponent(props) {
  const { height, diameter, color } = props;
  const divStyle = {
    height: height || "100%"
  };
  return (
    <div style={divStyle} className="loader-parent">
      <TailSpin
        height={diameter || 80}
        width={diameter || 80}
        color={color || "#000000"}
        ariaLabel="tail-spin-loading"
        radius="1"
        wrapperClass="loader"
        visible
      />
    </div>
  );
}
export default LoadingComponent;
